import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FaqDataService {
    private controllerUrl: string = `FAQ/`;

    constructor(
        private baseApi: BaseApiService<any>,
    ) { }


    TermsAndConditions(): Observable<any> {
        return this.baseApi.Get(`${this.controllerUrl}TermsAndConditions`);
    }
    GetAcknowledgmentsReports (): Observable<any> {
        return this.baseApi.Get(`${this.controllerUrl}GetAcknowledgmentsReports `);
    }
    GetUsagePolicy (): Observable<any> {
        return this.baseApi.Get(`${this.controllerUrl}GetUsagePolicy`);
    }
    FAQS (): Observable<any> {
        return this.baseApi.Get(`${this.controllerUrl}FAQS`);
    }
    Policies (): Observable<any> {
        return this.baseApi.Get(`${this.controllerUrl}Policies`);
    }
    InterestConflicts (): Observable<any> {
        return this.baseApi.Get(`${this.controllerUrl}InterestConflicts`);
    }
    ShariaaCompliances (): Observable<any> {
        return this.baseApi.Get(`${this.controllerUrl}ShariaaCompliances`);
    }
    About (): Observable<any> {
        return this.baseApi.Get(`${this.controllerUrl}About`);
    }
}